<template>
    <div class="report">
        <Public></Public>

        <div class="report-content right-content">
            <el-tabs v-model="activeIndex" type="card" @tab-click="handleClick">
                <el-tab-pane label="入住率" name="1">
                    <ReportOccupancyrate></ReportOccupancyrate>
                </el-tab-pane>

                <el-tab-pane label="无数据上报统计" name="2">
                    <ReportOnlinenodata></ReportOnlinenodata>
                </el-tab-pane>

                <el-tab-pane label="公摊为负数报表" name="3">
                    <ReportNegative></ReportNegative>
                </el-tab-pane>

                <el-tab-pane label="断电设备" name="4">
                    <ReportOutage></ReportOutage>
                </el-tab-pane>

                <el-tab-pane label="两天无个人用电" name="5">
                    <ReportTwoday></ReportTwoday>
                </el-tab-pane>

                <el-tab-pane label="欠费设备" name="6">
                    <ReportArrears></ReportArrears>
                </el-tab-pane>

                <el-tab-pane label="水表明细" name="7">
                    <ReportWater></ReportWater>
                </el-tab-pane>

              <el-tab-pane label="每个房间用电" name="8">
                <ReportRoom></ReportRoom>
              </el-tab-pane>
                <!--<el-tab-pane label="欠费房源" name="third"></el-tab-pane>-->

            </el-tabs>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    import Public from '@/views/Public.vue'
    import ReportOccupancyrate from '@/components/ReportOccupancyrate.vue'
    import ReportArrears from '@/components/ReportArrears.vue'
    import ReportOffline from '@/components/ReportOffline.vue'
    import ReportOnlinenodata from '@/components/ReportOnlinenodata.vue'
    import ReportNegative from '@/components/ReportNegative.vue'
    import ReportOutage from '@/components/ReportOutage.vue'
    import ReportTwoday from '@/components/ReportTwoday.vue'
    import ReportWater from '@/components/ReportWater.vue'
    import ReportRoom from '@/components/ReportRoom.vue'

    export default {
        name: "Report",
        components: {
            Public,
            ReportOccupancyrate,
            ReportArrears,
            ReportOffline,
            ReportOnlinenodata,
            ReportNegative,
            ReportOutage,
            ReportTwoday,
            ReportWater,
            ReportRoom
        },
        data() {
            return {
                activeIndex: '1',
            };
            },
            mounted() {
                if (window.localStorage.isChild == 1) {
                    this.$router.push('/house');
                } else {
                    this.activeIndex = store.state.reportTableTabIndex;
                }
        },
        methods: {
            handleClick(tab, event) {
                store.commit('assignReportTableTabIndex', this.activeIndex);

                console.log(tab, event)
            },
        }
    }
</script>

<style scoped>
    .report {
        height: 100%;
    }

    .report-content {
        margin: 0.1rem 0.5rem 0.1rem 0.15rem;
    }
    .right-content .report-table {
        margin-right: 0.3rem;
    }

    .select-search{
        margin: 0 0.3rem 0.2rem 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

    }
    .select-group {
        /*margin: 0 0 0.2rem 0.15rem;*/
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width:100%;
    }


    .select-group .el-select {
        margin-right: 5%;
    }

    .button-group {
        display: flex;
        flex-direction: row-reverse;
    }
    .button-group .el-button{
        margin-left: 5%;
    }


</style>